import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"18px"}
}, "arrow_back", -1)
const _hoisted_3 = {
  key: 1,
  class: "banner banner-success"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " check ", -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 2,
  class: "mb-4 items-center flex space-x-0.5 md:space-x-2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, "arrow_back", -1)
const _hoisted_8 = { class: "mb-0.5 pl-2" }
const _hoisted_9 = {
  key: 3,
  class: "px-2 py-6"
}
const _hoisted_10 = { class: "flex flex-col mb-6 space-y-8" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "flex space-x-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "my-auto text-sm material-icons-outlined" }, " timer ", -1)
const _hoisted_14 = { class: "" }
const _hoisted_15 = {
  key: 0,
  class: "flex space-x-1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "my-auto text-sm material-icons-outlined" }, " assignment_turned_in ", -1)
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "flex flex-col space-y-2" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col items-center mb-2 space-y-2 md:flex-row md:space-x-8 md:space-y-0"
}
const _hoisted_20 = { class: "card card-filled shadow-elevation md:w-5/12" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg icon-light material-icons" }, "edit", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg text-gray-600 material-icons-outlined" }, "undo", -1)
const _hoisted_25 = { class: "my-4 text-muted" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = {
  key: 1,
  class: "banner banner-light"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, "info", -1)
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = {
  key: 2,
  class: "banner banner-light"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, "sync_disabled", -1)
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = {
  key: 3,
  class: "banner banner-danger"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base text-2xl text-yellow-900 material-icons-outlined" }, "pending_actions", -1)
const _hoisted_35 = { class: "text-muted text-danger-dark" }
const _hoisted_36 = { class: "mb-1" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 4,
  class: "py-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot")!
  const _component_ExerciseSolutionContainer = _resolveComponent("ExerciseSolutionContainer")!
  const _component_SlotSkeleton = _resolveComponent("SlotSkeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.journeySlug)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Btn, {
            onClick: _ctx.goToCourseJourney,
            variant: "ghost",
            size: "sm",
            class: "flex items-center gap-1"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("learning_journey.back_to_journey")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.params.showSubmissionConfirmationMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("event_participation_page.turned_in_text")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading && _ctx.mainStore.currentEventParticipation && _ctx.allowEditAssessment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          false
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                onClick: _ctx.onGoBack,
                outline: true,
                variant: 'icon'
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.mainStore.currentEventParticipation.event.event_type === _ctx.EventType.EXAM
						? _ctx.$t("event_assessment.viewing_participation_of")
						: _ctx.$t("event_assessment.viewing_practice_of")) + " " + _toDisplayString(_ctx.mainStore.currentEventParticipation.user.full_name), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.firstLoading && _ctx.mainStore.currentEventParticipation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("event_participation_page.begin_timestamp")) + ":", 1),
                _createVNode(_component_Timestamp, {
                  value: _ctx.mainStore.currentEventParticipation.begin_timestamp,
                  class: "text-muted"
                }, null, 8, ["value"])
              ]),
              (_ctx.mainStore.currentEventParticipation.end_timestamp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("event_participation_page.turn_in_timestamp")) + ":", 1),
                    _createVNode(_component_Timestamp, {
                      class: "text-muted",
                      value: _ctx.mainStore.currentEventParticipation.end_timestamp
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_ctx.showAssessmentCard && !_ctx.firstLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h4", _hoisted_22, [
                          _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.overall_score")) + ": ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.mainStore.currentEventParticipation.score), 1)
                        ]),
                        (_ctx.allowEditAssessment)
                          ? (_openBlock(), _createBlock(_component_Btn, {
                              key: 0,
                              outline: true,
                              variant: 'icon',
                              disabled: _ctx.showEditScore,
                              class: "ml-1",
                              tooltip: _ctx.showEditScore ? '' : _ctx.$t('help_texts.edit_overall_grade'),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowEditScore()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            }, 8, ["disabled", "tooltip"]))
                          : _createCommentVNode("", true),
                        (_ctx.mainStore.currentEventParticipation.score_edited)
                          ? (_openBlock(), _createBlock(_component_Btn, {
                              key: 1,
                              outline: true,
                              class: "ml-auto",
                              variant: 'icon',
                              disabled: _ctx.showEditScore,
                              tooltip: _ctx.$t('event_assessment.undo_score_edit_tooltip'),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUndoScoreEdit()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 1
                            }, 8, ["disabled", "tooltip"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([{
									'max-h-0': !_ctx.showEditScore,
									'max-h-96': _ctx.showEditScore,
								}, "flex flex-col max-w-md space-y-4 overflow-y-hidden duration-200 ease-in-out lg:max-w-lg transition-max-height"])
                      }, [
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("event_assessment.overall_score_instructions")), 1),
                        _createVNode(_component_TextInput, {
                          modelValue: _ctx.dirtyScore,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dirtyScore) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.overall_score")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_Btn, {
                            class: "ml-auto mr-2",
                            outline: false,
                            variant: 'primary',
                            loading: _ctx.assessmentLoading,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onHideEditScore()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.confirm_assessment")), 1)
                            ]),
                            _: 1
                          }, 8, ["loading"]),
                          _createVNode(_component_Btn, {
                            outline: true,
                            disabled: _ctx.assessmentLoading,
                            variant: 'primary',
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onHideEditScore(true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("dialog.default_cancel_text")), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
							_ctx.allowEditAssessment && !_ctx.mainStore.currentEventParticipation.score_edited
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("event_assessment.default_score")), 1)
                  ]))
                : (
							_ctx.allowEditAssessment && _ctx.mainStore.currentEventParticipation.score_edited
						)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("event_assessment.you_overrode_score")), 1)
                    ]))
                  : _createCommentVNode("", true),
              (
							_ctx.allowEditAssessment &&
							_ctx.someSlotsPending &&
							!_ctx.mainStore.currentEventParticipation.score_edited
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("event_assessment.some_slots_pending")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.currentEventParticipation.slots, (slot, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{
					'mt-0': index === 0,
					'mb-5': index === _ctx.mainStore.currentEventParticipation.slots.length - 1,
					'mb-10': index !== _ctx.mainStore.currentEventParticipation.slots.length - 1,
				}, ""]),
              key: 'p-' + _ctx.mainStore.currentEventParticipation.id + '-s-' + slot.id
            }, [
              _createVNode(_component_AbstractEventParticipationSlot, {
                modelValue: slot,
                onSaveAssessment: ($event: any) => (_ctx.onSlotSaveAssessment($event.slot, $event.changes)),
                allowEditAssessment: _ctx.allowEditAssessment,
                showSolutionAndScores: _ctx.showSolutionAndScores,
                showAssessmentCard: _ctx.showAssessmentCard,
                assessmentControlsVisibility: _ctx.slotsAssessmentControlsVisibility,
                onSetAssessmentExpanded: ($event: any) => (
						_ctx.slotsAssessmentControlsVisibility[$event.slot.id] = $event.payload
					),
                assessmentLoading: _ctx.slotsAssessmentLoading[slot.id] ?? false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t("event_participation_page.exercise")) + " " + _toDisplayString(slot.slot_number + 1), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onSaveAssessment", "allowEditAssessment", "showSolutionAndScores", "showAssessmentCard", "assessmentControlsVisibility", "onSetAssessmentExpanded", "assessmentLoading"]),
              (
						_ctx.showSolutionAndScores &&
						!_ctx.allowEditAssessment &&
						!_ctx.slotsLoadingSolution[slot.id]
					)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_ExerciseSolutionContainer, {
                      exercise: slot.exercise,
                      solutions: _ctx.getSolutionsForExercise(slot.exercise),
                      class: "mt-4",
                      showExerciseThreadLink: true,
                      allowShowMore: false,
                      initialEditorContent: slot.answer_text
                    }, null, 8, ["exercise", "solutions", "initialEditorContent"])
                  ]))
                : (_ctx.slotsLoadingSolution[slot.id])
                  ? (_openBlock(), _createBlock(_component_SlotSkeleton, {
                      key: 1,
                      class: "mt-2"
                    }))
                  : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton),
          _createVNode(_component_SlotSkeleton)
        ]))
  ]))
}